// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3Laqt","resendInfoText":"OnGoingPaymentBox_resendInfoText__3OIDO"};